<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » エントリー情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>エントリー情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-entry.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 条件ボタン
        </div>
        <div class="manual-explain">
          クリックすることで<a [href]="manualSelectEntranceExitEntryDialogLink">エントリー情報検索条件ダイアログ</a>を表示します。<br>
          エントリー情報検索条件ダイアログで検索条件を設定すると、その内容でエントリー情報を検索します。(初期表示時は無条件です)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・属性
        </div>
        <div class="manual-explain">
          エントリー一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: 登録者、メールアドレス、環境
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> エントリー一覧
        </div>
        <div class="manual-explain">
          登録済みのエントリー情報の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 入退場状況
        </div>
        <div class="manual-explain">
          入退場状況のアイコンをクリックすることで<a [href]="manualEntranceExitTransitDialogLink">入退場状況ダイアログ</a>が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Entry Information
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Entry Information</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-entry.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Conditions Button
        </div>
        <div class="manual-explain">
          Click to display the <a [href]="manualSelectEntranceExitEntryDialogLink">Entry Information Search Conditions Dialog</a>.<br>
          When search conditions are set in the Entry Information Search Conditions Dialog, entry information will be searched with those conditions. (No conditions by default)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Click to delete the selected information.<br>
          The button is activated by checking the delete checkboxes in the list.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the entry list.<br>
          *Filtering targets: Registrant, Email Address, Environment
        </div>


        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Entry List
        </div>
        <div class="manual-explain">
          Displays a list of registered entry information.<br>
          Click the edit icon to display the edit screen.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Entry/Exit Status
        </div>
        <div class="manual-explain">
          Click the entry/exit status icon to display the <a [href]="manualEntranceExitTransitDialogLink">Entry/Exit Status Dialog</a>.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
